import React, {PureComponent} from "react";
import {DialogManagerProps} from "../../../../../store/dialog-manager/types";
import QuestionScene from "../../../../../scenes/question/QuestionScene";
import {LoadingIndicator} from "../../../loading/LoadingIndicator";
import {IApplicationState} from "../../../../../store";
import {connect} from "react-redux";
import {Overlay} from "../../../overlay/Overlay";

interface QuestionDialogProps {
    isQuestionAlreadyFetched: boolean;
    continueButtonText?: string;
}

class QuestionDialog extends PureComponent<QuestionDialogProps & DialogManagerProps> {
    render() {
        const content = this.props.isQuestionAlreadyFetched
            ? (
                <QuestionScene continueButtonText={this.props.continueButtonText}/>
            )
            : (
                <LoadingIndicator/>
            );

        return (
            <Overlay opacity={1}>
                {content}
            </Overlay>
        );
    }
}

export default connect(({ game, questions }: IApplicationState) => ({
    isQuestionAlreadyFetched: !!game.questions[questions.currentQuestionId]
}))(QuestionDialog);